<template>
    <div>
        <div class="flex justify-content-between">
            <div>
                <h4>{{ title }}</h4>
            </div>
        </div>
        <hr/>
        <div v-if="firstStep">

            <div class="custom-height pb-3">
                <div>
                    <div class="flex flex-column automation-trigger p-1 pb-3 mt-2">
                        <div class="mb-2">
                            <div>Trigger</div>
                        </div>
                        <div class="trigger br-10">
                            When a
                            <button class="btn btn-primary mr-2 capitalize" v-if="form.automation_object">{{ form.automation_object }}</button>
                            <span v-if="form.automation_trigger">
                                is
                            <button class="btn btn-light-green mr-4 capitalize">{{form.automation_trigger.replace('_', ' ')}}</button>
                                then...
                            </span>

                        </div>
                    </div>
                </div>
                <div class="mt-3 mb-3">
                    <p class="mb-1">1. Select an automation type <span class="required-field">*</span></p>
                    <div>
                        <button class="btn btn-blue text-white mr-2" :class="getSelectedClass('event_based')"
                                @click="changeSelected('automation_type', 'event_based')">Event based</button>
                        <button class="btn btn-blue text-white" :class="getSelectedClass('time_based')"
                                data-toggle="modal" data-target="#timeBasedModal">Time based</button>
                    </div>
                </div>
                <div class="mt-3 mb-3" v-if="form.automation_type">
                    <p class="mb-1">2. Select an object <span class="required-field">*</span></p>
                    <div>
                        <button class="btn btn-primary mr-2" :class="getSelectedClass('project')" @click="changeSelected('object', 'project')">Project</button>
                        <button class="btn btn-primary mr-2" :class="getSelectedClass('company')" @click="changeSelected('object', 'company')" :disabled="form.time_based.time_operator === 'before'">Company</button>
                        <button class="btn btn-primary mr-2" :class="getSelectedClass('contact')" @click="changeSelected('object', 'contact')">Contact</button>
                        <button class="btn btn-primary" :class="getSelectedClass('sequence')" @click="changeSelected('object', 'sequence')" :disabled="form.time_based.time_operator === 'before'">Sequence</button>
                    </div>
                </div>
                <div class="mt-3 mb-3" v-if="form.automation_object">
                    <p class="mb-1">3. Select a trigger <span class="required-field">*</span></p>
                    <div v-if="(['project', 'company', 'contact'].includes(form.automation_object))">
                        <button class="btn btn-light-green mr-2" :class="getSelectedClass('created')" @click="changeSelected('trigger', 'created')" :disabled="isButtonDisabled">Created</button>
                        <button class="btn btn-light-green mr-2" :class="getSelectedClass('deleted')" @click="changeSelected('trigger', 'deleted')" :disabled="isButtonDisabled">Deleted</button>
                        <button class="btn btn-light-green mr-2" :class="getSelectedClass('updated')" @click="changeSelected('trigger', 'updated')" :disabled="isButtonDisabled">Update</button>
                        <button class="btn btn-light-green mr-2" :class="getSelectedClass('not_updated')" @click="changeSelected('trigger', 'not_updated')" v-if="form.automation_type === 'time_based' && (['project', 'contact'].includes(form.automation_object))" :disabled="isButtonDisabled">Not Updated</button>
                        <button class="btn btn-light-green mr-2" :class="getSelectedClass('activity_added')" @click="changeSelected('trigger', 'activity_added')" v-if="(['project', 'contact'].includes(form.automation_object))" :disabled="isButtonDisabled">Activity Added</button>
                        <button class="btn btn-light-green mr-2" :class="getSelectedClass('activity_completed')" @click="changeSelected('trigger', 'activity_completed')" v-if="(['project', 'contact'].includes(form.automation_object))" :disabled="isButtonDisabled">Activity Completed</button>
                        <button class="btn btn-light-green mr-2" :class="getSelectedClass('activity_due')" @click="changeSelected('trigger', 'activity_due')" v-if="form.automation_type === 'time_based' && (['project', 'contact'].includes(form.automation_object))">Activity Due</button>
                    </div>
                    <div v-else>
                        <button class="btn btn-light-green mr-2" :class="getSelectedClass('apply')" @click="changeSelected('trigger', 'apply')">Applied</button>
                        <button class="btn btn-light-green mr-2" :class="getSelectedClass('remove')" @click="changeSelected('trigger', 'remove')">Removed</button>
                    </div>
                </div>
                <div class="mt-3 mb-3" v-if="(form.automation_trigger === 'created' || form.automation_trigger === 'updated') && (['project', 'company', 'contact'].includes(form.automation_object))">
                    <p class="mb-1">4. Condition <span v-if="form.automation_trigger !== 'created'" class="required-field">*</span></p>
                    <div>
                        <button class="btn btn-purple text-white mr-2" data-toggle="modal" data-target="#conditionModal" :class="getSelectedClass('field')">Add Condition</button>
                    </div>
                </div>
                <div class="mt-3 mb-3" v-if="(['not_updated', 'activity_added', 'activity_completed', 'activity_due'].includes(form.automation_trigger))">
                    <p class="mb-1">4. Select a field <span v-if="form.automation_trigger !== 'not_updated'" class="required-field">*</span></p>
                    <div>
                        <button class="btn btn-purple text-white mr-2 capitalize" data-toggle="modal" data-target="#fieldModal" :class="getSelectedClass('field')">{{(this.form.automation_field !== 'empty') ? this.form.automation_field.replace(/_/g, ' ') : 'Field'}}</button>
                    </div>
                </div>
                <div class="mt-3 mb-3" v-if="form.automation_trigger === 'not_updated' && (['project', 'contact'].includes(form.automation_object)) && form.automation_field !== 'empty'">
                    <p class="mb-1">5. Select a field to exclude {{ form.automation_object }}</p>
                    <div>
                        <button class="btn btn-purple text-white mr-2" data-toggle="modal" data-target="#fieldExcludeModal" :class="getSelectedClass('exclude_field')">Field To Exclude</button>
                    </div>
                </div>
                <!-- <div class="mt-3 mb-3"  v-if="(form.automation_type === 'event_based' && (form.automation_trigger  === 'created' || form.automation_trigger  === 'updated') && form.automation_field !== 'empty') ||
                 ( (form.automation_trigger  === 'created' || form.automation_trigger  === 'updated') && form.automation_field !== 'empty' && form.time_based.time_value !== null && form.time_based.time_filter === 'empty')">
                    <p class="mb-1">5. Add a filter <span class="required-field">*</span></p>
                    <div>
                        <button class="btn btn-light-red mr-2" data-toggle="modal" data-target="#filterModal" :class="getSelectedClass('filter')">Add a filter</button>
                    </div>
                </div> -->

                <div class="card w-50 mt-4" v-if="form.automation_conditions.length > 0">
                    <div class="card-header">
                        <h6> Conditions </h6>
                    </div>
                    <ul class="list-group list-group-flush">
                        <li class="list-group-item" v-for="(condition, index) in form.automation_conditions" :key="'condition'+index">If <strong class="text-capitalize"> {{ condition.trigger_label }} </strong> is {{ condition.trigger_operator }} <strong>{{ condition.trigger_value_display }} </strong>
                            <button class="btn btn-sm btn-light-red float-right mr-2" @click="removeCondition(condition)"> <i class="fa fa-trash" aria-hidden="true"></i> </button>
                        </li>
                    </ul>
                </div>

                <div class="card w-50 mt-4" v-if="form.exclude_field && form.exclude_field !== 'empty'">
                    <div class="card-header">
                        <h6 class="capitalize"> Excluded field <b>{{ form.exclude_field.replace(/_/g, ' ') }}</b></h6>
                    </div>
                    <ul class="list-group list-group-flush">
                        <li class="list-group-item" v-for="(item, index) in filteredFieldsSelectedValues" :key="'excludeValue'+index">
                            <strong class="text-capitalize"> {{ item.code }} </strong>
                        </li>
                    </ul>
                </div>

                <div v-if="data_loading" class="text-5xl text-grey-darkest text-center mt5">
                    <i class="fa fa-spin fa-spinner" aria-hidden="true"></i>
                </div>
            </div>
            <div class="mt-5 mb-4">
                <button class="btn btn-light-red mr-2" @click="goToAutomations">Back</button>
                <button class="btn btn-success" @click="goToNext">Next</button>
            </div>
        </div>
        <div v-else>
            <div class="custom-height pb-3">
                <div>
                    <div class="flex flex-column automation-trigger p-1 pb-3 mt-2">
                        <div class="mb-2">
                            <div>Trigger</div>
                        </div>
                        <div class="trigger br-10">
                            When a
                            <button class="btn btn-primary mr-2 capitalize" v-if="form.automation_object">{{ form.automation_object }}</button>
                            <span v-if="form.automation_trigger">
                                is
                            <button class="btn btn-light-green mr-4 capitalize">{{form.automation_trigger.replace('_', ' ')}}</button>
                                then...
                            </span>
                            <button class="btn btn-light-yellow mr-2 capitalize" v-if="form.action">{{ form.action.replace('action_', '') }}</button>
                            <button class="btn btn-primary mr-2 capitalize" v-if="form.action_object">{{ form.action_object.replace('action_', '') }}</button>

                        </div>
                    </div>
                </div>
                <div class="mt-3 mb-3">
                    <p class="mb-1">1. Select an action <span class="required-field">*</span></p>
                    <div>
                        <button class="btn btn-light-yellow mr-2" :class="getSelectedClass('action_update')" @click="changeSelected('action', 'action_update')" :disabled="form.automation_trigger === 'deleted' || form.automation_object === 'sequence'  || (form.time_based.time_operator === 'before' && form.automation_type === 'time_based')">Update</button>
                        <button class="btn btn-light-yellow mr-2" :class="getSelectedClass('action_email')" @click="changeSelected('action', 'action_email')">Email</button>
<!--                        <button class="btn btn-light-yellow mr-2" :class="getSelectedClass('action_notify')" @click="changeSelected('action', 'action_notify')">Notify</button>-->
                    </div>
                </div>
                <div class="mt-3 mb-3" v-if="form.action">
                    <p class="mb-1">2. Choose an object <span class="required-field">*</span></p>
                    <div>
                        <button class="btn btn-primary mr-2" :class="getSelectedClass('action_project')" @click="changeSelected('action_object', 'action_project')" :disabled="form.automation_object !== 'project'">Project</button>
                        <button class="btn btn-primary mr-2" :class="getSelectedClass('action_company')" @click="changeSelected('action_object', 'action_company')" v-if="form.action === 'action_update'" :disabled="form.action === 'action_update' && form.automation_object !== 'company'">Company</button>
                        <button class="btn btn-primary mr-2" :class="getSelectedClass('action_contact')" @click="changeSelected('action_object', 'action_contact')" :disabled="form.automation_object !== 'contact'">Contact</button>
                        <button class="btn btn-primary mr-2" :class="getSelectedClass('action_user')" @click="changeSelected('action_object', 'action_user')" v-if="form.action !== 'action_update'">User</button>
<!--                        <button class="btn btn-primary mr-2" :class="getSelectedClass('action_new_contact')" @click="changeSelected('action_object', 'action_new_contact')" v-if="form.automation_type === 'time_based' && form.automation_trigger === 'created' && form.automation_object === 'contact' && form.action !== 'action_update'" title="Email to new created contact">New Contact</button>-->
                    </div>
                </div>
                <div class="mt-3 mb-3" v-if="(form.action === 'action_update' && form.action_object &&  (['action_project', 'action_contact', 'action_company'].includes(form.action_object))) || (form.action !== 'action_update' && (form.action_object === 'action_user' || form.action_object === 'action_project'))">
                    <p class="mb-1">3. Add a filter <span class="required-field">*</span></p>
                    <div>
                        <button class="btn btn-light-red mr-2 capitalize" data-toggle="modal" data-target="#filterActionModal">{{(form.action === 'action_email' && ((form.action_object === 'action_user' && (typeof form.action_field_object !== 'object' && form.action_field_object)) || form.action_object === 'action_project' && form.project_email_user)) ? (selectedUserForEmail ? selectedUserForEmail: selectedProjectEmailType.replace(/_/g, ' ')) : 'Add a filter'}}</button>
                        <p v-if="form.action_field !== 'empty'" class='mt-2'>Set <b class="capitalize">{{form.action_field.replace(/_/g, ' ')}}</b> to <b>{{(selectedActionValue) ? selectedActionValue : form.input_action_value}}</b></p>
                    </div>
                </div>
                <div class="mt-3 mb-3" v-if="form.action && form.action_object && form.action !== 'action_update' && (form.action_object === 'action_contact')">
                    <p class="mb-1">3. Add a Template <span class="required-field">*</span></p>
                    <div>
                        <button class="btn btn-primary mr-2 mt-2" @click.stop.prevent="openEmailTemplateModal">{{ (selectedTemplateName) ? selectedTemplateName : 'Template'}}</button>

                    </div>
                </div>
                <div class="mt-3 mb-3" v-if="form.action && form.action !== 'action_update' && ((typeof form.action_field_object !== 'object' && form.action_field_object) || form.project_email_user)">
                    <p class="mb-1">4. Add a Template <span class="required-field">*</span></p>
                    <div>
                        <button class="btn btn-primary mr-2 mt-2" @click.stop.prevent="openEmailTemplateModal">{{ (selectedTemplateName) ? selectedTemplateName : 'Template'}}</button>

                    </div>
                </div>
            </div>
            <div class="mt-5 mb-4">
                <button class="btn btn-light-red mr-2" @click="goBack">Back</button>
                <button v-if="buttonTitle==='Update'" class="btn btn-success" @click="updateAutomation">Update</button>
                <button v-else class="btn btn-success" @click="saveAutomation">Save</button>
            </div>
        </div>

        <div id="timeBasedModal" class="modal fade" role="dialog">
            <div class="modal-dialog modal-md modal-dialog-centered">
                <!-- Modal content-->
                <div class="modal-content schedule-modal">
                    <div class="modal-body text-dark">
                        <h5 class="text-center mb-4">Time Based</h5>
                        <div class="row d-flex align-items-end">
                            <div class="col-4">
                                <span class="text-sm">Trigger this when</span>
                            </div>
                            <div class="col-8 d-flex align-content-around">
                                <input type="number" name="time_value" min="1" @input="debounceTimeBased"
                                       v-model="form.time_based.time_value" class="form-control-sm border-1 br-5 mr-2">

                                <select name="time_unit" class="btn-blue form-control-sm text-white br-5" v-model="form.time_based.time_unit">
                                    <option value="minutes">Minutes</option>
                                    <option value="hours">Hours</option>
                                    <option value="days">Days</option>
                                </select>
                            </div>
                        </div>
                        <div class="row mt-4">
                            <div class="col-4">
                                <span class="mr-4">After/before</span>
                            </div>
                            <div class="col-8">
                                <select name="time_operator" class="btn-blue form-control-sm text-white br-5" v-model="form.time_based.time_operator" @change="changeSaleBehaviorValue">
                                    <option value="after" selected>After</option>
                                    <option value="before">Before</option>
                                </select>
                            </div>
                        </div>
                        <div class="row mt-4">
                            <div class="col-4">
                                <span class="mr-4">Starting on</span>
                            </div>
                            <div class="col-8">
                                <select class="btn-blue form-control-sm text-white br-5"
                                        name="starting_day" v-model="form.time_based.starting_day">
                                    <option value="Monday">Monday</option>
                                    <option value="Tuesday">Tuesday</option>
                                    <option value="Wednesday">Wednesday</option>
                                    <option value="Thursday">Thursday</option>
                                    <option value="Friday">Friday</option>
                                    <option value="Saturday">Saturday</option>
                                    <option value="Sunday">Sunday</option>
                                </select>
                            </div>
                        </div>
                        <div class="row mt-4">
                            <div class="col-4">
                                <span class="mr-4">At this time</span>
                            </div>
                            <div class="col-8">
                                <select v-model="form.time_based.starting_time" class="btn-blue form-control-sm text-white br-5"
                                        name="starting_time">
                                    <option v-for="(item, index) in times" :value="item.property_name">{{ item.name }}</option>
                                </select>
                            </div>
                        </div>
                    </div>

                    <div class="text-right mt-4">
                        <button class="btn btn-primary" data-dismiss="modal">
                            Save
                        </button>

                    </div>
                </div>
            </div>
        </div>

        <div id="conditionModal" class="modal fade" role="dialog">
            <div class="modal-dialog modal-lg modal-dialog-centered">
                <!-- Modal content-->
                <div class="modal-content schedule-modal">
                    <div class="modal-header">
                        <h5 class="text-center mb-2">Select Condition</h5>
                        <button type="button" dusk="modal-close-button"
                                class="material-icons focus:outline-none text-grey-darkest hover:text-grey-darkest"
                                data-dismiss="modal"
                                @click="closeConditionModal">close
                        </button>
                    </div>
                    <div class="modal-body text-dark p-0">
                        <div class="flex justify-center">
                            <div class="container mt-4">
                                <div class="row">
                                    <div class="col-md-4">
                                        <b-form-select v-model="form.automation_field" v-if="form.automation_object === 'project'" class="mb-3" id="project_select" @change="selectField">
                                            <b-form-select-option value="empty" id="project-empty1">Please select an option</b-form-select-option>
                                            <b-form-select-option v-for="(item, index) in allProjectFields" :value="item.property_name" :key="'project'+index">{{ item.name }}</b-form-select-option>
                                        </b-form-select>
                                        <b-form-select v-model="form.automation_field" v-if="form.automation_object === 'company'" class="mb-3" id="company_select" @change="selectField">
                                            <b-form-select-option value="empty" id="company-empty1">Please select an option</b-form-select-option>
                                            <b-form-select-option v-for="(item, index) in company_fields" :value="item.property_name" :key="'company'+index">{{ item.name }}</b-form-select-option>
                                        </b-form-select>
                                        <b-form-select v-model="form.automation_field" v-if="form.automation_object === 'contact'" class="mb-3" id="contact_select" @change="selectField">
                                            <b-form-select-option value="empty" id="contact-empty1">Please select an option</b-form-select-option>
                                            <b-form-select-option v-for="(item, index) in allContactFields" :value="item.property_name" :key="'contact'+index">{{ item.name }}</b-form-select-option>
                                        </b-form-select>
                                    </div>

                                    <div class="col-md-4">
                                        <b-form-select v-model="form.trigger_operator" class="mb-3">
                                            <b-form-select-option value="equal to" selected>is equal to</b-form-select-option>
                                            <b-form-select-option value="not equal to">is not equal to</b-form-select-option>
                                        </b-form-select>
                                    </div>

                                    <div class="col-md-4">
                                        <input class="form-control-sm field-height" type="text" v-if="form.field_object.type === 'text'" v-model="form.input_value" key="text">

                                        <b-form-select class="form-control-sm field-height" v-if="form.field_object.type === 'dropdown'" v-model="form.input_value">
                                            <b-form-select-option value="empty" id="filter-empty1">Please select an option</b-form-select-option>
                                            <b-form-select-option v-for="(item, index) in dropdown_options" :value="item.id" :key="'filter'+index">{{ item.code }}</b-form-select-option>
                                        </b-form-select>

                                        <b-form-select class="form-control-sm field-height" v-if="form.field_object.type === 'user'" v-model="form.input_value">
                                            <b-form-select-option value="empty" id="user-empty1">Please select an option</b-form-select-option>
                                            <b-form-select-option v-for="(item, index) in dropdown_user_values" :value="item.id" :key="'user'+index">{{ item.name }}</b-form-select-option>
                                        </b-form-select>

                                        <input type="text" name="contact_phone"
                                               v-if="form.field_object.type === 'phone'"
                                               key="phone"
                                               v-mask="['(###) ###-####', '(###) ###-#### ext. #####']"
                                               id="contact_phone1"
                                               class="form-control-sm field-height"
                                               v-model="form.input_value">

                                        <currency-input
                                            v-if="form.field_object.type === 'money'"
                                            id="contract_amount1"
                                            name="contract_amount"
                                            locale="us"
                                            :currency="null"
                                            class="form-control-sm field-height"
                                            v-model="form.input_value">
                                        </currency-input>

                                        <datepicker
                                            v-if="form.field_object.type === 'date'"
                                            :format="'MM/dd/yyyy'" :use-utc="true"
                                            wrapper-class="field-height form-control-sm"
                                            v-model="form.input_value"
                                            input-class="date-picker-ui"
                                        ></datepicker>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="text-right mt-4">
                            <button class="btn btn-primary" data-dismiss="modal" @click="saveCondition">Save</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div id="fieldModal" class="modal fade" role="dialog">
            <div class="modal-dialog modal-dialog-centered">
                <!-- Modal content-->
                <div class="modal-content schedule-modal">
                    <div class="modal-body text-dark p-0">
                        <h5 class="text-center mb-2">Select Field</h5>
                        <div class="flex justify-center">
                            <b-form-select v-model="form.automation_field" v-if="form.automation_object === 'project'" class="mb-3" id="project_select" @change="selectField">
                                <b-form-select-option value="empty" id="project-empty2">Please select an option</b-form-select-option>
                                <b-form-select-option v-for="(item, index) in allProjectFields" :value="item.property_name" :key="'project'+index">{{ item.name }}</b-form-select-option>
                            </b-form-select>
                            <b-form-select v-model="form.automation_field" v-if="form.automation_object === 'company'" class="mb-3" id="company_select" @change="selectField">
                                <b-form-select-option value="empty" id="company-empty2">Please select an option</b-form-select-option>
                                <b-form-select-option v-for="(item, index) in company_fields" :value="item.property_name" :key="'company'+index">{{ item.name }}</b-form-select-option>
                            </b-form-select>
                            <b-form-select v-model="form.automation_field" v-if="form.automation_object === 'contact'" class="mb-3" id="contact_select" @change="selectField">
                                <b-form-select-option value="empty" id="contact-empty2">Please select an option</b-form-select-option>
                                <b-form-select-option v-for="(item, index) in allContactFields" :value="item.property_name" :key="'contact'+index">{{ item.name }}</b-form-select-option>
                            </b-form-select>
                        </div>
                        <div class="text-right mt-4">
                            <button class="btn btn-primary" data-dismiss="modal">Save</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div id="filterActionModal" class="modal fade" role="dialog">
            <div class="modal-dialog modal-dialog-centered">
                <!-- Modal content-->
                <div class="modal-content schedule-modal p-0">
                    <div class="modal-body text-dark">
                        <h5 class="text-center mb-2">Filter</h5>
                        <div class="flex align-items-center justify-content-between mt-5">

                            <!--                            if action  == update show field dropdown-->
                            <div v-if="form.action === 'action_update'">
                                <b-form-select v-model="form.action_field" v-if="form.action_object === 'action_project'" id="action_project_select" @change="actionFieldChange">
                                    <b-form-select-option value="empty" id="action-project-empty">Please select an option</b-form-select-option>
                                    <b-form-select-option v-for="(item, index) in allProjectActionFields" :value="item.property_name" :key="'project'+index">{{ item.name }}</b-form-select-option>
                                </b-form-select>
                                <b-form-select v-model="form.action_field" v-if="form.action_object === 'action_company'" id="action_company_select" @change="actionFieldChange">
                                    <b-form-select-option value="empty" id="action-company-empty">Please select an option</b-form-select-option>
                                    <b-form-select-option v-for="(item, index) in company_fields" :value="item.property_name" :key="'company'+index">{{ item.name }}</b-form-select-option>
                                </b-form-select>
                                <b-form-select v-model="form.action_field" v-if="form.action_object === 'action_contact'" id="action_contact_select" @change="actionFieldChange">
                                    <b-form-select-option value="empty" id="action-contact-empty">Please select an option</b-form-select-option>
                                    <b-form-select-option v-for="(item, index) in allContactActionFields" :value="item.property_name" :key="'contact'+index">{{ item.name }}</b-form-select-option>
                                </b-form-select>
                            </div>
                            <div v-if="form.action !== 'action_update'" class="w-100 text-center">

                                <b-form-select v-model="form.action_field_object" class="form-control-sm" v-if="form.action_object === 'action_user'">
                                    <b-form-select-option value="empty" id="action-user-empty0">Please select an option</b-form-select-option>
                                    <b-form-select-option v-for="(item, index) in dropdown_user_values" :value="item.id" :key="'user'+index">{{ item.name }}</b-form-select-option>
                                </b-form-select>

                                <b-form-select v-model="form.project_email_user" class="form-control-sm" v-if="form.action_object === 'action_project'" @change="selectedProjectEmailOption">
                                    <b-form-select-option value="project_contact" id="project_contact">Project Contact</b-form-select-option>
                                    <b-form-select-option value="account_manager" id="account_manager">Account Manager</b-form-select-option>
                                    <b-form-select-option value="estimator" id="estimator">Estimator</b-form-select-option>
                                    <b-form-select-option value="take_off_person" id="take_off_person">Take Off Person</b-form-select-option>
                                    <b-form-select-option value="company_contact" id="company_contact">Company Contact - First Contact</b-form-select-option>
                                </b-form-select>

<!--                                <b-form-select v-model="form.action_field_object" class="form-control-sm" v-if="form.action_object === 'action_project'">-->
<!--                                    <b-form-select-option value="empty" id="action-project-empty0">Please select an option</b-form-select-option>-->
<!--                                    <b-form-select-option v-for="(item, index) in project_options" :value="item.id" :key="'user'+index">{{ item.name }}</b-form-select-option>-->
<!--                                </b-form-select>-->

<!--                                <b-form-select v-model="form.action_field_object" class="form-control-sm" v-if="form.action_object === 'action_company'">-->
<!--                                    <b-form-select-option value="empty" id="action-company-empty0">Please select an option</b-form-select-option>-->
<!--                                    <b-form-select-option v-for="(item, index) in company_options" :value="item.id" :key="'user'+index">{{ item.name }}</b-form-select-option>-->
<!--                                </b-form-select>-->

<!--                                <b-form-select v-model="form.action_field_object" class="form-control-sm" v-if="form.action_object === 'action_contact'">-->
<!--                                    <b-form-select-option value="empty" id="action-contact-empty0">Please select an option</b-form-select-option>-->
<!--                                    <b-form-select-option v-for="(item, index) in contact_options" :value="item.id" :key="'user'+index">{{ item.name }}</b-form-select-option>-->
<!--                                </b-form-select>-->
                            </div>

                            <div v-if="form.action === 'action_update'">

                                <input class="form-control" type="text" v-if="form.action_field_object.type === 'text'" v-model="form.input_action_value" key="text">

                                <b-form-select class="form-control" v-if="form.action_field_object.type === 'dropdown'"  v-model="selectedActionObject" @change="selectedActionOption">
                                    <b-form-select-option value="empty" id="action_dropdown">Please select an option</b-form-select-option>
                                    <b-form-select-option v-for="(item, index) in action_dropdown_options" :value="item" :key="'filter'+index">{{ item.code }}</b-form-select-option>
                                </b-form-select>

                                <b-form-select class="form-control" v-if="form.action_field_object.type === 'user'" v-model="selectedActionObject" @change="selectedActionUserOption">
                                    <b-form-select-option value="empty" id="action_user_empty">Please select an option</b-form-select-option>
                                    <b-form-select-option v-for="(item, index) in dropdown_user_values" :value="item" :key="'user'+index">{{ item.name }}</b-form-select-option>
                                </b-form-select>

                                <input type="text" name="contact_phone"
                                       v-if="form.action_field_object.type === 'phone'"
                                       key="phone"
                                       v-mask="['(###) ###-####', '(###) ###-#### ext. #####']"
                                       id="action_contact_phone"
                                       class="form-control"
                                       v-model="form.input_action_value">

                                <currency-input
                                    v-if="form.action_field_object.type === 'money'"
                                    id="action_contract_amount"
                                    name="contract_amount"
                                    locale="us"
                                    :currency="null"
                                    class="form-control"
                                    v-model="form.input_action_value">
                                </currency-input>

                                <datepicker
                                    v-if="form.action_field_object.type === 'date'"
                                    :format="'MM/dd/yyyy'" :use-utc="true"
                                    wrapper-class="form-control"
                                    v-model="form.input_action_value"
                                    input-class="date-picker-ui"
                                ></datepicker>
                            </div>

                        </div>
                        <div class="text-right mt-5">
                            <button class="btn btn-primary" data-dismiss="modal">
                                Save
                            </button>

                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div id="fieldExcludeModal" class="modal fade" role="dialog">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content schedule-modal p-0">
                    <div class="modal-body text-dark">
                        <h5 class="text-center mb-2">Select Field</h5>
                        <div class="flex align-items-center justify-content-between mt-5">

                            <div class="w-100 text-center">
                                <b-form-select v-model="form.exclude_field" v-if="form.automation_object === 'project'" id="exclude_project_select" @change="selectExcludeField">
                                    <b-form-select-option value="empty" id="project-exclude">Please select an option</b-form-select-option>
                                    <b-form-select-option v-for="(item, index) in filteredProjectFields" :value="item.property_name" :key="'project'+index">{{ item.name }}</b-form-select-option>
                                </b-form-select>
                                <b-form-select v-model="form.exclude_field" v-if="form.automation_object === 'contact'" id="exclude_contact_select" @change="selectExcludeField">
                                    <b-form-select-option value="empty" id="contact-exclude">Please select an option</b-form-select-option>
                                    <b-form-select-option v-for="(item, index) in filteredContactFields" :value="item.property_name" :key="'contact'+index">{{ item.name }}</b-form-select-option>
                                </b-form-select>
                            </div>

                            <div class="w-100 text-center ml-2">
                                <multiselect
                                    v-model="filteredFieldsSelectedValues"
                                    id="exclude_action_dropdown"
                                    :options="exclude_dropdown_options"
                                    :multiple="true"
                                    :close-on-select="true"
                                    :clear-on-select="true"
                                    :preserve-search="true"
                                    open-direction="below"
                                    placeholder="Select Options"
                                    label="code"
                                    track-by="id"
                                    @select="filteredFieldsSelected"
                                >
                                </multiselect>
                            </div>

                        </div>
                        <div class="text-right mt-5">
                            <button class="btn btn-primary" data-dismiss="modal" type="button">
                                Save
                            </button>

                        </div>
                    </div>
                </div>
            </div>
        </div>

        <email-template-modal-ckeditor ref="EmailTemplateModal" v-on:addTemplateToEmail="selectTemplate" :allFields="templateFields" :isAutomation="true" :automationObject="form.automation_object"></email-template-modal-ckeditor>
    </div>
</template>

<script>
import Multiselect from 'vue-multiselect';
import ProjectField from "../../assets/fields-data/project-fields.json";
import CompanyField from "../../assets/fields-data/company-fields.json";
import ContactField from "../../assets/fields-data/contact-fields.json";
import TemplateFields from "../../assets/fields-data/automation-template-fields.json";
import Times from "../../assets/fields-data/times.json";
import Datepicker from 'vuejs-datepicker';
import {CurrencyInput} from "vue-currency-input";
import Swal from "sweetalert2";
import moment from "moment";

export default {
    name:'customize-automation',
    components: {Datepicker, CurrencyInput, Multiselect},
    props: ['automation', 'title', 'buttonTitle', 'fieldLabels', 'projectDataFieldVisibility'],
    data() {
        return {
            // project_fields:ProjectField,
            company_fields:CompanyField,
            // contact_fields:ContactField,
            times: Times,
            firstStep: true,
            dropdown_user_values:null,
            dropdown_options: [],
            action_dropdown_options: [],
            exclude_dropdown_options: [],
            // project_options: [],
            // company_options: [],
            // contact_options: [],
            company_types: [],
            contact_types: [],
            all_codes: [],
            form: {
                automation_type:null,
                automation_object:null,
                automation_trigger:null,
                automation_field:'empty',
                trigger_operator: 'equal to',
                action_field:'empty',
                automation_filter:null,
                input_value: null,
                input_action_value: null,
                action: null,
                action_object: null,
                field_object: {
                    name: '',
                    property_name:'',
                    type: 'text'
                },
                action_field_object: {
                    name: '',
                    property_name:'',
                    type: 'text'
                },
                time_based:{
                    time_value:null,
                    time_unit:"minutes",
                    time_operator:"after",
                    starting_day:"Monday",
                    // time_filter:"empty",
                    starting_time:Times[0].property_name,
                },
                automation_exclude_field: 'empty',
                exclude_field: 'empty',
                exclude_field_values: [],
                automation_conditions: [],
                project_email_user: null,
            },
            data_loading: false,
            automation_template_id: null,
            filteredFieldsSelectedValues: [],
            selectedTemplateName: null,
            selectedActionValue: null,
            selectedActionObject: null,
            team_contact_statuses: [],
            selectedProjectEmailType: null,
            customFields: [],
        }
    },
    async created() {
        this.data_loading = true;
        await this.fetchCodes();
        await this.fetchGeneralData();
        await this.initiateForm();
        this.data_loading = false;
    },
    mounted() {
        this.fetchCustomFields();
    },
    watch: {
        filteredFieldsSelectedValues(val) {
            if(val) {
                const self = this;
                self.form.exclude_field_values = val.map(obj => obj.id);
            }
        },
        'form.automation_field': function(newVal, oldVal) {
            if(oldVal !== 'empty') {
                const self = this;
                self.form.automation_exclude_field = 'empty';
                self.form.exclude_field = null;
                self.filteredFieldsSelectedValues = null;
                self.form.exclude_field_values = null;
            }
        },
        'form.exclude_field': function(newVal, oldVal) {
            if(oldVal !== 'empty') {
                const self = this;
                self.filteredFieldsSelectedValues = null;
                self.form.exclude_field_values = null;
            }
        },
        'form.action_field': function(newVal, oldVal) {
            const self = this;

            if(oldVal !== 'empty') {
                self.form.input_action_value = null;
            }

            if(newVal === self.automation.action_field) {

                const moneyFields = ['contract_amount', 'gross_margin_percentage', 'labor_hours', 'base_bid']
                if(moneyFields.includes(self.automation.action_field)) {
                    self.$nextTick(() => {
                        let actionValue = parseFloat(self.automation.input_action_value) / 100;
                        self.form.input_action_value = parseFloat(actionValue);
                    });
                } else {
                    self.form.input_action_value = self.automation.input_action_value;
                }

                const integersArray = ['contract_type_id', 'office_id', 'sales_status_id', 'lead_from_id', 'estimator_id',
                    'account_manager_id', 'take_off_person_id', 'product_and_services_id',
                    'client_profile_id', 'marketing_status_id'];

                if(integersArray.includes(self.form.action_field)) {
                    self.$nextTick(() => {
                        self.form.input_action_value = parseInt(self.automation.input_action_value);
                    });
                }
            }
        },
    },
    methods: {
        changeSaleBehaviorValue(val) {
            const self = this;
            self.form.automation_object = null;
            self.form.automation_trigger = null;
            self.form.automation_conditions = [];

            // if(self.form.time_based.time_operator === 'before') {
            //     self.form.time_based.time_filter = 'due_date'
            // }else{
            //     self.form.time_based.time_filter = 'empty'
            // }
        },
        async initiateForm() {
            if(this.automation.automation_type === 'time_based'){
                this.form.time_based.time_value = this.automation.time_value
                this.form.time_based.time_unit = this.automation.time_unit
                this.form.time_based.time_operator = this.automation.time_operator
                // this.form.time_based.time_filter = this.automation.time_filter ?? "empty"
                this.form.time_based.starting_day = this.automation.starting_day
                this.form.time_based.starting_time = this.automation.starting_time

                if(this.automation.exclude_field && this.automation.exclude_field_value) {
                    this.form.automation_exclude_field = 'exclude_field';
                    this.form.exclude_field = this.automation.exclude_field;
                    this.form.exclude_field_values = this.automation.exclude_field_value;

                    let allFields = [];
                    let excludeFieldValues = JSON.parse(this.automation.exclude_field_value);

                    switch (this.automation.exclude_field) {
                        case 'sales_status_id':
                            allFields = this.all_codes.sales_status
                            break;
                        case 'marketing_status_id':
                            allFields = this.all_codes.marketing_status
                            break;
                        case 'lead_from_id':
                            allFields = this.all_codes.lead_from
                            break;
                        case 'client_profile_id':
                            allFields = this.all_codes.client_profile
                            break;
                        case 'contract_type_id':
                            allFields = this.all_codes.contract_type
                            break;
                        case 'office_id':
                            allFields = this.all_codes.office
                            break;
                        case 'products_and_services_id':
                            allFields = this.all_codes.products_and_services
                            break;
                        case 'company_types_id':
                            allFields = this.company_types
                            break;
                        case 'contact_types_id':
                            allFields = this.contact_types
                            break;
                    }

                    if(allFields && excludeFieldValues) {
                        this.filteredFieldsSelectedValues = allFields.filter(item => excludeFieldValues.includes(item.id));
                    }
                }
            }
            this.form.automation_template_id = this.automation.automation_template_id ?? null
            this.form.automation_type = this.automation.automation_type
            this.form.automation_object = this.automation.automation_object
            this.form.automation_trigger = this.automation.automation_trigger
            this.form.automation_field = this.automation.trigger_field ?? 'empty'
            this.form.action = this.automation.action
            this.form.action_object = this.automation.action_object
            this.form.action_field = (this.automation.action_field && this.automation.action_field !== '' && this.automation.action_field !== 'empty')? this.automation.action_field : 'empty'
            this.form.automation_conditions = this.automation.automation_conditions
            this.selectedTemplateName = this.automation.selected_template_name
            this.form.project_email_user = this.automation.project_email_user
            if(this.form.project_email_user && this.form.project_email_user === 'company_contact'){
                this.selectedProjectEmailType = 'Company Contact - First Contact'
            }else{
                this.selectedProjectEmailType = this.form.project_email_user;
            }
            if(this.automation.action_field){
                this.form.action_field = this.automation.action_field
                await this.actionFieldChange(this.automation.action_field);
                let inputActionValue = this.automation.input_action_value;

                const moneyFieldActionFields = ['contract_amount', 'gross_margin_percentage', 'labor_hours', 'base_bid']
                if(moneyFieldActionFields.includes(this.automation.action_field)) {
                    inputActionValue = parseFloat(this.automation.input_action_value) / 100;
                    inputActionValue = parseFloat(inputActionValue);
                }
                this.form.input_action_value = inputActionValue;

                if(this.action_dropdown_options.length > 0){
                    this.selectedActionObject =  this.action_dropdown_options.find(x => x.id = this.form.input_action_value)
                    this.selectedActionValue =  this.selectedActionObject.code
                }

            }else{
                this.form.action_field_object = this.automation.input_action_value
            }
        },
        async fetchCodes(){
            const self = this;
            await axios.get(route('api.project.codes')).then(({data}) => {
                this.all_codes = data;
                self.dropdown_user_values = data.users

            });
        },
        async fetchGeneralData() {
            const self = this;
            await axios.get(route('automation.get-data')).then(({data}) => {
                // self.project_options = data.projects;
                // self.company_options = data.companies;
                // self.contact_options = data.contacts;
                self.company_types = data.company_types;
                self.contact_types = data.contact_types;
                self.team_contact_statuses = data.team_contact_statuses;
                self.sales_behaviours = data.sales_behaviours.map( x =>({ name: x.name, property_name: x.name.toLowerCase()
                        .replace(/ /g, '_')
                        .replace(/[^\w-]+/g, ''),type: 'date'}));
                self.contact_activities = data.contact_activities.map( x =>({ name: x.name, property_name: x.name.toLowerCase()
                        .replace(/ /g, '_')
                        .replace(/[^\w-]+/g, ''),type: 'date'}));
            });

        },
        saveSelectField:function (){
            $("#fieldModal").modal("hide");
        },
        changeSelected:function (type, val){
            const self = this;

            switch(type) {
                case 'automation_type':
                    self.form.automation_type = val
                    self.form.automation_object = null
                    self.form.automation_trigger = null
                    self.form.action = null
                    self.form.action_object = null
                    self.form.time_based.time_value = null
                    self.form.time_based.time_unit = 'minutes'
                    self.form.time_based.time_operator = 'after'
                    // self.form.time_based.time_filter = 'empty'
                    self.form.time_based.starting_day = 'Monday'
                    self.form.time_based.starting_time = '12:00 PM'
                    self.form.automation_exclude_field = 'empty'
                    self.form.field_object = {
                        name: '',
                        property_name:'',
                        type: 'text'
                    }
                    self.filteredFieldsSelectedValues = null
                    self.form.exclude_field = null
                    self.form.exclude_field_values = null
                    self.form.automation_conditions = [];
                    self.form.project_email_user = null;

                    break;
                case 'object':
                    self.form.automation_object = val
                    self.form.automation_trigger = null
                    self.form.action = null
                    self.form.action_object = null
                    self.form.automation_exclude_field = 'empty'
                    self.form.field_object = {
                        name: '',
                        property_name:'',
                        type: 'text'
                    }
                    self.filteredFieldsSelectedValues = null
                    self.form.exclude_field = null
                    self.form.exclude_field_values = null
                    self.form.automation_conditions = [];
                    self.form.project_email_user = null;

                    break;
                case 'trigger':
                    self.form.automation_trigger = val
                    self.form.action = null
                    self.form.action_object = null
                    self.form.automation_exclude_field = 'empty'
                    self.form.field_object = {
                        name: '',
                        property_name:'',
                        type: 'text'
                    }
                    self.filteredFieldsSelectedValues = null
                    self.form.exclude_field = null
                    self.form.exclude_field_values = null
                    self.form.automation_conditions = [];
                    self.form.project_email_user = null;

                    break;
                case 'action':
                    self.form.action = val
                    self.form.action_object = null
                    self.form.input_action_value = null;
                    self.form.action_field = 'empty';
                    self.form.action_field_object = {
                        name: '',
                        type: 'text'
                    }
                    self.form.project_email_user = null;
                    break;
                case 'action_object':
                    self.form.action_object = val
                    self.form.input_action_value = null;
                    self.form.action_field = 'empty';
                    self.form.action_field_object = {
                        name: '',
                        type: 'text'
                    }
                    self.form.project_email_user = null;
                    break;
            }
        },
        getSelectedClass:function (val){
            const self = this;
            if(self.form.automation_type === val){
                return 'selected_button'
            }
            if(self.form.automation_object === val){
                return 'selected_button'
            }
            if(self.form.automation_trigger === val){
                return 'selected_button'
            }
            if(self.form.automation_exclude_field === val){
                return 'selected_button'
            }
            // if(val === 'field' && self.form.automation_field !== 'empty'){
            //     return 'selected_button'
            // }
            if(self.form.automation_filter === val){
                return 'selected_button'
            }
            if(self.form.action === val){
                return 'selected_button'
            }
            if(self.form.action_object === val){
                return 'selected_button'
            }
            return ''

        },
        goToNext(){
            const isValid = this.validateCreateFields('next');
            if(!isValid) {
                return false
            }
            this.firstStep = false;
        },
        goBack(){
            this.firstStep = true;
        },
        goToAutomations(){
            window.location = route('automation.index');
        },
        setFieldObject(fields, item) {
            const self = this;
            self.form.input_value = null;
            self.form.field_object = fields.find(element => element.property_name === item)
        },
        selectField(item) {
            const self = this;

            switch(self.form.automation_object) {
                case 'project':
                    self.setFieldObject(self.allProjectFields, item);
                    break;
                case 'company':
                    self.setFieldObject(self.company_fields, item);
                    break;
                case 'contact':
                    self.setFieldObject(self.allContactFields, item);
                    break;
            }

            switch (self.form.field_object.property_name) {
                case 'sales_status_id':
                    self.dropdown_options = self.all_codes.sales_status
                    break;
                case 'marketing_status_id':
                    self.dropdown_options = self.all_codes.marketing_status
                    break;
                case 'lead_from_id':
                    self.dropdown_options = self.all_codes.lead_from
                    break;
                case 'client_profile_id':
                    self.dropdown_options = self.all_codes.client_profile
                    break;
                case 'contract_type_id':
                    self.dropdown_options = self.all_codes.contract_type
                    break;
                case 'office_id':
                    self.dropdown_options = self.all_codes.office
                    break;
                case 'products_and_services_id':
                    self.dropdown_options = self.all_codes.products_and_services
                    break;
                case 'company_types_id':
                    self.dropdown_options = self.company_types
                    break;
                case 'contact_types_id':
                    self.dropdown_options = self.contact_types
                    break
                case 'team_contact_status':
                    self.dropdown_options = self.team_contact_statuses
                    break;
            }

        },
        selectExcludeField() {
            const self = this;

            switch (self.form.exclude_field) {
                case 'sales_status_id':
                    self.exclude_dropdown_options = self.all_codes.sales_status
                    break;
                case 'marketing_status_id':
                    self.exclude_dropdown_options = self.all_codes.marketing_status
                    break;
                case 'lead_from_id':
                    self.exclude_dropdown_options = self.all_codes.lead_from
                    break;
                case 'client_profile_id':
                    self.exclude_dropdown_options = self.all_codes.client_profile
                    break;
                case 'contract_type_id':
                    self.exclude_dropdown_options = self.all_codes.contract_type
                    break;
                case 'office_id':
                    self.exclude_dropdown_options = self.all_codes.office
                    break;
                case 'products_and_services_id':
                    self.exclude_dropdown_options = self.all_codes.products_and_services
                    break;
                case 'company_types_id':
                    self.exclude_dropdown_options = self.company_types
                    break;
                case 'contact_types_id':
                    self.exclude_dropdown_options = self.contact_types
                    break;
                case 'team_contact_status':
                    self.exclude_dropdown_options = self.team_contact_statuses
                    break;
            }
        },
        setActionFieldObject(fields, item) {
            const self = this;
            let action_field_object = fields.find(element => element.property_name === item);
            self.form.action_field_object = action_field_object ? action_field_object : { name: '', property_name:'', type: 'text'}
        },
        actionFieldChange(item) {
            const self = this;
            self.selectedActionValue = null;
            self.form.input_action_value = null;
            self.selectedActionObject = null;
            switch(self.form.action_object) {
                case 'action_project':
                    self.setActionFieldObject(self.allProjectActionFields, item);
                    break;
                case 'action_company':
                    self.setActionFieldObject(self.company_fields, item);
                    break;
                case 'action_contact':
                    self.setActionFieldObject(self.allContactActionFields, item);
                    break;
            }

            switch (self.form.action_field_object.property_name) {
                case 'sales_status_id':
                    self.action_dropdown_options = self.all_codes.sales_status
                    break;
                case 'marketing_status_id':
                    self.action_dropdown_options = self.all_codes.marketing_status
                    break;
                case 'lead_from_id':
                    self.action_dropdown_options = self.all_codes.lead_from
                    break;
                case 'client_profile_id':
                    self.action_dropdown_options = self.all_codes.client_profile
                    break;
                case 'contract_type_id':
                    self.action_dropdown_options = self.all_codes.contract_type
                    break;
                case 'office_id':
                    self.action_dropdown_options = self.all_codes.office
                    break;
                case 'products_and_services_id':
                    self.action_dropdown_options = self.all_codes.products_and_services
                    break;
                case 'company_types_id':
                    self.action_dropdown_options = self.company_types
                    break;
                case 'contact_types_id':
                    self.action_dropdown_options = self.contact_types
                    break;
                case 'team_contact_status':
                    self.action_dropdown_options = self.team_contact_statuses
                    break;
            }

        },
        updateAutomation(){
            const self = this;
            const isValid = self.validateCreateFields('save');
            if(!isValid){
                return false;
            }
            let payload = { ...self.form,
                automation_id: self.automation.id,
            }
            axios.post(route('automation.update-automation', payload)).then((response) => {
                if (response.status) {
                    this.getToast(1000).fire({
                        type: 'success',
                        title: response.data.message
                    });
                    window.location = route('automation.index');
                } else {
                    this.getToast().fire({
                        type: 'error',
                        title: response.data.message
                    });
                }
            });
        },
        saveAutomation(){
            const self = this;
            const isValid = self.validateCreateFields('save');
            if(!isValid){
                return false;
            }

            axios.post(route('automation.save-automation', self.form)).then((response) => {
                if (response.status) {
                    this.getToast(1000).fire({
                        type: 'success',
                        title: response.data.message
                    });
                    window.location = route('automation.index');
                } else {
                    this.getToast().fire({
                        type: 'error',
                        title: response.data.message
                    });
                }
            });
        },
        validateCreateFields(type){
            const self = this;
            switch(type) {
                case 'next':
                    if(!self.form.automation_type) {
                        self.showToast('error', 'Please select automation type')
                        return false
                    }
                    if(!self.form.automation_object) {
                        self.showToast('error', 'Please select automation object')
                        return false
                    }
                    if(!self.form.automation_trigger) {
                        self.showToast('error', 'Please select automation trigger')
                        return false
                    }
                    if(self.form.automation_trigger === 'updated' && self.form.automation_conditions.length === 0) {
                        self.showToast('error', 'Please add conditions');
                        return false;
                    }
                    if(['activity_added', 'activity_completed', 'activity_due'].includes(self.form.automation_trigger) && self.form.automation_field === 'empty') {
                        self.showToast('error', 'Please select field ');
                        return false;
                    }
                    return true
                    break;
                case 'save':
                    if(!self.form.action) {
                        self.showToast('error', 'Please select action')
                        return false
                    }
                    if(!self.form.action_object) {
                        self.showToast('error', 'Please select action object')
                        return false
                    }

                    if(self.form.action_object !== 'action_new_contact') {
                        if(self.form.action === 'action_update' && self.form.action_object !== 'action_user' &&
                            self.form.action_field !== 'empty' && (!self.form.input_action_value || self.form.input_action_value === ''))
                        {
                            self.showToast('error', 'Please select action field value')
                            return false
                        }

                        if(self.form.action === 'action_update' && self.form.action_field === 'empty') {
                            self.showToast('error', 'Please select action filter')
                            return false
                        }
                        if(self.form.action !== 'action_update' && self.form.action_field === 'empty' && self.form.action_field_object && (typeof self.form.action_field_object == 'object' || self.form.action_field_object === "empty") && self.form.action_object !== 'action_project' && self.form.action_object !== 'action_contact') {
                            self.showToast('error', 'Please select action filter')
                            return false
                        }
                        if(self.form.action !== 'action_update' && typeof self.form.action_field_object != 'object' && self.form.action_field_object && self.form.automation_template_id === null) {
                            self.showToast('error', 'Please select template')
                            return false
                        }
                        if(self.form.action !== 'action_update' && self.form.automation_template_id === null && (self.form.action_object === 'action_project' || self.form.action_object === 'action_contact')) {
                            self.showToast('error', 'Please select template')
                            return false
                        }
                    }else{
                        if(self.form.action !== 'action_update' && self.form.automation_template_id === null) {
                            self.showToast('error', 'Please select template')
                            return false
                        }
                    }
                    return true
                    break;

            }
        },
        showToast(type, title){
            const Toast = Swal.mixin({
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 2000
            });
            Toast.fire({
                type: type,
                title: title
            });
        },
        debounceTimeBased: _.debounce(function(e) {
            const self = this;
            if(e.target.value && e.target.value !== ""){
                self.form.automation_type = 'time_based';
                // self.form.time_based.time_operator = 'after'
                // self.form.time_based.time_filter = 'empty'
                // self.project_fields = [...self.project_fields, ...self.sales_behaviours];
            }else{
                self.form.automation_type = null
            }
            self.form.automation_object = null
            self.form.automation_trigger = null
            self.form.action = null
            self.form.action_object = null
            self.form.automation_conditions = [];
        }, 600),
        selectTemplate(template){
            this.selectedTemplateName = template.template_name
            this.form.automation_template_id = template.id
        },
        openEmailTemplateModal(){
            this.$refs.EmailTemplateModal.open(true);
        },
        filteredFieldsSelected() {
            const self = this;
            self.form.automation_exclude_field = 'exclude_field';
        },
        saveCondition() {
            if(this.form.automation_field && this.form.trigger_operator && this.form.input_value) {
                let field = this.form.automation_field;
                let label = this.formatTriggerLabel(field);
                let triggerValueDisplay = '';

                switch (this.form.automation_field) {
                    case 'sales_status_id':
                        let salesStatus = this.all_codes.sales_status.find(element => element.id === this.form.input_value);
                        triggerValueDisplay = salesStatus.code;
                        break;
                    case 'client_profile_id':
                        let clientProfile = this.all_codes.client_profile.find(element => element.id === this.form.input_value);
                        triggerValueDisplay = clientProfile.code;
                        break;
                    case 'contract_type_id':
                        let contractType = this.all_codes.contract_type.find(element => element.id === this.form.input_value);
                        triggerValueDisplay = contractType.code;
                        break;
                    case 'marketing_status_id':
                        let marketingStatus = this.all_codes.marketing_status.find(element => element.id === this.form.input_value);
                        triggerValueDisplay = marketingStatus.code;
                        break;
                    case 'lead_from_id':
                        let leadFrom = this.all_codes.lead_from.find(element => element.id === this.form.input_value);
                        triggerValueDisplay = leadFrom.code;
                        break;
                    case 'office_id':
                        let office = this.all_codes.office.find(element => element.id === this.form.input_value);
                        triggerValueDisplay = office.code;
                        break;
                    case 'products_and_services_id':
                        let productsAndService = this.all_codes.products_and_services.find(element => element.id === this.form.input_value);
                        triggerValueDisplay = productsAndService.code;
                        break;
                    case 'company_types_id':
                        let companyType = this.company_types.find(element => element.id === this.form.input_value);
                        triggerValueDisplay = companyType.code;
                        break;
                    case 'contact_types_id':
                        let contactType = this.contact_types.find(element => element.id === this.form.input_value);
                        triggerValueDisplay = contactType.code;
                        break;
                    case 'estimator_id':
                    case 'account_manager_id':
                    case 'take_off_person_id':
                    case 'user_id':
                        let user = this.all_codes.users.find(element => element.id === this.form.input_value);
                        triggerValueDisplay = user.name;
                        break;
                    case 'dead_date':
                    case 'pre_bid':
                    case 'bid_date':
                    case 'contract_date':
                    case 'followup':
                        triggerValueDisplay = moment(this.form.input_value).format('YYYY-MM-DD')
                        break;
                    case 'contract_amount':
                    case 'base_bid':
                    case 'gross_margin_percentage':
                    case 'labor_hours':
                        triggerValueDisplay = parseFloat(this.form.input_value).toFixed(2)
                        break;
                    case 'team_contact_status':
                        let teamContactStatus = this.team_contact_statuses.find(element => element.id === this.form.input_value);
                        triggerValueDisplay = teamContactStatus.code;
                        break;
                    default:
                        let projectSalesBehaviors = [];
                        projectSalesBehaviors = this.getProjectSalesBehaviors();
                        let contactSalesBehaviors = [];
                        contactSalesBehaviors = this.getContactSalesBehaviors();

                        if(projectSalesBehaviors.includes(this.form.automation_field) || contactSalesBehaviors.includes(this.form.automation_field)) {
                            triggerValueDisplay = moment(this.form.input_value).format('YYYY-MM-DD')
                            break;
                        } else {
                            triggerValueDisplay = this.form.input_value;
                            break;
                        }
                }
                let condition = {
                    trigger_label: label,
                    trigger_field: this.form.automation_field,
                    trigger_operator: this.form.trigger_operator,
                    trigger_value: this.form.input_value,
                    trigger_value_display: triggerValueDisplay
                };
                let conditions = this.form.automation_conditions;
                let alreadyExist = conditions.find(element => element.trigger_field === this.form.automation_field);
                if(alreadyExist) {
                    this.getToast(1000).fire({
                        type: 'error',
                        title: this.ucwords(alreadyExist.trigger_label) + ' condition is already exist!'
                    });
                } else {
                    conditions.push(condition);
                }
            }
            this.form.automation_field = null;
            this.form.trigger_operator = 'equal to';
            this.form.input_value = null;
        },
        closeConditionModal() {
            this.form.automation_field = null;
            this.form.trigger_operator = 'equal to';
            this.form.input_value = null;
        },
        removeCondition(condition) {
            let conditions = this.form.automation_conditions;
            conditions = conditions.filter(element => element.trigger_field != condition.trigger_field);
            this.form.automation_conditions = conditions;
        },
        formatTriggerLabel(field) {
            let label = '';
            switch (field) {
                case "gross_margin_percentage":
                    label = 'Gross Margin';
                    break;
                case "contact_types_id":
                    label = 'Contact Type';
                    break;
                case "company_types_id":
                    label = 'Company Type';
                    break;
                case "sales_status_id":
                case "marketing_status_id":
                case "lead_from_id":
                case "client_profile_id":
                case "contract_type_id":
                case "account_manager_id":
                case "office_id":
                case "estimator_id":
                case "take_off_person_id":
                case "user_id":
                case "products_and_services_id":
                    label = field.replace("_id", " ");
                    break;
                default:
                    label = field;
                    break;
            }

            label = label.replaceAll("_", " ");
            return label;
        },
        getProjectSalesBehaviors() {
            let projectSaleBehaviorsArray = [];
            let projectSalesBehaviours = this.sales_behaviours;

            if(projectSalesBehaviours.length > 0) {
                projectSalesBehaviours.forEach((projectSaleBehavior) => {
                    projectSaleBehaviorsArray.push(projectSaleBehavior.property_name);
                });
            }

            return projectSaleBehaviorsArray;
        },
        getContactSalesBehaviors() {
            let contactSaleBehaviorsArray = [];
            let contactSalesBehaviours = this.allContactFields.filter(contact => contact.type === 'date');
            if(contactSalesBehaviours.length > 0) {
                contactSalesBehaviours.forEach((contactSaleBehavior) => {
                    contactSaleBehaviorsArray.push(contactSaleBehavior.property_name);
                });
            }

            return contactSaleBehaviorsArray;
        },
        selectedActionOption(option) {
            this.form.input_action_value = option.id
            this.selectedActionValue = option.code
        },
        selectedActionUserOption(user) {
            this.form.input_action_value = user.id
            this.selectedActionValue = user.name
        },
        selectedProjectEmailOption(value) {
            if(value === 'company_contact'){
                this.selectedProjectEmailType = 'Company Contact - First Contact'
            }else{
                this.selectedProjectEmailType = value;
            }
        },
        addCustomFieldsAndSalesActivities(projectFields){
            let salesActivitiesData = [];
            if(this.all_codes?.sales_activities?.length > 0){
                this.all_codes.sales_activities.forEach((item, index) => {
                    let numberToAppend = index+508;
                    salesActivitiesData.push({
                        id: numberToAppend,
                        button: 'add'+item.name.replace(/\b\w/g, char => char.toUpperCase()).replace(/\s+/g, ''),
                        text: item.name,
                        buttonCode: 'replace'+item.name.replace(/\b\w/g, char => char.toUpperCase()).replace(/\s+/g, '')
                    })
                })
            }
            projectFields[1].optionValues = salesActivitiesData;

            let formattedCustomfields = [];
            let counter = 29;
            formattedCustomfields = this.customFields.map(field => {
                if(field.enabled == 1){
                    const fieldName = field.label_value.replace(/\s+/g, '')
                    counter++;
                    return {
                        id: counter,
                        button: 'add'+fieldName,
                        text: field.label_value,
                        buttonCode: 'replace'+fieldName
                    }
                }
            });
            if(formattedCustomfields.length > 0){
                formattedCustomfields = formattedCustomfields.filter(item => item !== undefined);
            }
            projectFields[2].optionValues = formattedCustomfields;
            return this.applyFieldLabels(projectFields);
        },
        fetchCustomFields() {
            axios.get(route('api.project-custom-field.index')).then(({data}) => {
                this.customFields = data.data;
                this.addCustomFieldsAndSalesActivities(TemplateFields.project);
            });
        },
        applyFieldLabels(projectFields){
            if(projectFields.length > 0){
                console.log(projectFields);
                projectFields[0].optionValues.forEach(field => {
                    switch(field['text']) {
                        case 'Sales Status':
                            field['text'] = (this.projectDataFieldVisibility['sales-status'])? this.getFieldLabel(this.fieldLabels, 'sales-status'):null;
                            break;
                        case 'Marketing Status':
                            field['text'] = (this.projectDataFieldVisibility['marketing-status'])? this.getFieldLabel(this.fieldLabels, 'marketing-status'):null;
                            break;
                        case 'Pre Bid':
                            field['text'] = (this.projectDataFieldVisibility['pre-bid'])? this.getFieldLabel(this.fieldLabels, 'pre-bid'):null;
                            break;
                        case 'Bid Date':
                            field['text'] = (this.projectDataFieldVisibility['bid-date'])? this.getFieldLabel(this.fieldLabels, 'bid-date'):null;
                            break;
                        case 'Lead Source':
                            field['text'] = (this.projectDataFieldVisibility['lead-source'])? this.getFieldLabel(this.fieldLabels, 'lead-source'):null;
                            break;
                        case 'Estimator':
                            field['text'] = (this.projectDataFieldVisibility['estimator'])? this.getFieldLabel(this.fieldLabels, 'estimator'):null;
                            break;
                        case 'Account Manager':
                            field['text'] = (this.projectDataFieldVisibility['account-manager'])? this.getFieldLabel(this.fieldLabels, 'account-manager'):null;
                            break;
                        case 'Take Off Person':
                            field['text'] = (this.projectDataFieldVisibility['take-off-person'])? this.getFieldLabel(this.fieldLabels, 'take-off-person'):null;
                            break;
                        case 'Product And Services':
                            field['text'] = (this.projectDataFieldVisibility['products-and-services'])? this.getFieldLabel(this.fieldLabels, 'products-and-services'):null;
                            break;
                        case 'Client Profile':
                            field['text'] = (this.projectDataFieldVisibility['client-profile'])? this.getFieldLabel(this.fieldLabels, 'client-profile'):null;
                            break;
                        case 'Contract Type':
                            field['text'] = (this.projectDataFieldVisibility['contract-type'])? this.getFieldLabel(this.fieldLabels, 'contract-type'):null;
                            break;
                        case 'Office':
                            field['text'] = (this.projectDataFieldVisibility['office'])? this.getFieldLabel(this.fieldLabels, 'office'):null;
                            break;

                    }
                })
            }
            projectFields[0].optionValues = projectFields[0].optionValues.filter(item => item.text !== null);
            return projectFields;
        }
    },
    computed: {
        allProjectFields(){
            if (['activity_added', 'activity_completed', 'activity_due'].includes(this.form.automation_trigger)) {
                return this.sales_behaviours
            } else {
                return [...ProjectField, ...this.sales_behaviours];
            }
        },
        allContactFields(){
            if(this.form.automation_trigger !== 'created') {
                if (['activity_added', 'activity_completed', 'activity_due'].includes(this.form.automation_trigger)) {
                    return this.contact_activities
                } else {
                    return [...ContactField, ...this.contact_activities];
                }
            }else{
                return ContactField
            }
        },
        allContactActionFields(){
            return [...ContactField, ...this.contact_activities];
        },
        allProjectActionFields(){
            return [...ProjectField, ...this.sales_behaviours];
        },
        filteredProjectFields() {
            return this.allProjectActionFields.filter(project => project.type === 'dropdown');
        },
        filteredContactFields() {
            return this.allContactActionFields.filter(contact => contact.type === 'dropdown');
        },
        templateFields(){
            if(this.form.automation_trigger === 'deleted'){
                return [];
            }else{
                switch(this.form.automation_object) {
                    case 'project':
                        return this.addCustomFieldsAndSalesActivities(TemplateFields.project)
                        break;
                    case 'company':
                        return TemplateFields.company
                        break;
                    case 'contact':
                        return TemplateFields.contact
                        break;
                    default:
                        return TemplateFields.default
                        break;
                }
            }
        },
        isButtonDisabled() {
            return this.form.automation_type === 'time_based' && this.form.time_based.time_operator === 'before'
        },
        selectedUserForEmail() {
            let self = this;
            if(typeof self.form.action_field_object !== 'object' && self.form.action_field_object) {
                return self.dropdown_user_values.find(x => x.id === parseInt(self.form.action_field_object))?.name
            }else{
                return null;
            }
        }
    }
}
</script>
<style scoped>
.selected_button{
    border: 2px solid black;
    border-radius: 5px;
}
.automation-trigger {
    border-top: 1px solid #dae1e7;
    border-bottom: 1px solid #dae1e7;
}
.trigger{
    padding: 8px 30px;
    background: #ebebeb;
}
.btn-purple{
    background: #6e7ff2;
}
.btn-blue{
    background: #3c71b8;
}
.btn-light-green{
    background: #9af6c0;
}
.btn-light-red{
    background: #f87676;
}
.btn-light-red{
    background: #f87676;
}
.btn-light-yellow{
    background: #eeea7d;
}
.br-5{
    border-radius: 5px;
}
.field-height {
    min-height: 37px;
    max-height: 37px;
    border: 1px solid #b0b9bf
}
.card-header {
    background-color: rgba(0,0,0,.03);
}
.modal-header {
    background-color: inherit !important;
    border-bottom: none !important;
}
.date-picker-ui {
    height: 27px;
    width: 203px;
    border-radius: 4px;
}
.required-field {
    color: red;
}
</style>

